import {BusinessWalletTransfersCSV} from "@irati/types"
import {QueryBusinessWalletTransfersCSVArgs} from "@irati/types/ops"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"
import businessWalletTransfersCSVQuery, {businessWalletTransfersCSVKey} from "./queries/downloadBusinessWalletTransactions"

import coreErrorHandler from "./errors/walletErrorHandler"

class BusinessWalletService extends PBService {
  getBusinessWalletTransferCSV({
    tenantId,
    page,
    limit,
    includeHeaderRow
  }: QueryBusinessWalletTransfersCSVArgs, options: QueryOptions = {}): Promise<BusinessWalletTransfersCSV> {
    const variables = {tenantId, page, limit, includeHeaderRow}

    return client.query({
      ...options,
      query: businessWalletTransfersCSVQuery,
      variables
    }).then(({data}) => data[businessWalletTransfersCSVKey])
  }

}

export default new BusinessWalletService({errorHandlers: [coreErrorHandler]})
